"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AVAILABLE_ANALYTICS_SCHEMAS = exports.ANALYTICS_SCHEMA_VERSION_V3 = exports.ANALYTICS_SCHEMA_VERSION_V2_CALLBACK = exports.ANALYTICS_SCHEMA_VERSION_V2 = exports.ANALYTICS_SCHEMA_VERSION_EVENT_STREAM = void 0;

var _v = _interopRequireDefault(require("./v2"));

var _v2Callback = _interopRequireDefault(require("./v2-callback"));

var _v2 = _interopRequireDefault(require("./v3"));

var _eventStream = _interopRequireDefault(require("./event-stream"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ANALYTICS_SCHEMA_VERSION_V2 = 'ANALYTICS_SCHEMA_VERSION_V2';
exports.ANALYTICS_SCHEMA_VERSION_V2 = ANALYTICS_SCHEMA_VERSION_V2;
var ANALYTICS_SCHEMA_VERSION_V2_CALLBACK = 'ANALYTICS_SCHEMA_VERSION_V2_CALLBACK';
exports.ANALYTICS_SCHEMA_VERSION_V2_CALLBACK = ANALYTICS_SCHEMA_VERSION_V2_CALLBACK;
var ANALYTICS_SCHEMA_VERSION_V3 = 'ANALYTICS_SCHEMA_VERSION_V3';
exports.ANALYTICS_SCHEMA_VERSION_V3 = ANALYTICS_SCHEMA_VERSION_V3;
var ANALYTICS_SCHEMA_VERSION_EVENT_STREAM = 'ANALYTICS_SCHEMA_VERSION_EVENT_STREAM';
exports.ANALYTICS_SCHEMA_VERSION_EVENT_STREAM = ANALYTICS_SCHEMA_VERSION_EVENT_STREAM;
var AVAILABLE_ANALYTICS_SCHEMAS = [ANALYTICS_SCHEMA_VERSION_V2, ANALYTICS_SCHEMA_VERSION_V2_CALLBACK, ANALYTICS_SCHEMA_VERSION_V3, ANALYTICS_SCHEMA_VERSION_EVENT_STREAM];
exports.AVAILABLE_ANALYTICS_SCHEMAS = AVAILABLE_ANALYTICS_SCHEMAS;

var analyticsParser = function analyticsParser(schemaVersion, originalData) {
  var data = (0, _lodash.cloneDeep)(originalData);
  var implementedSchemaVersions = [ANALYTICS_SCHEMA_VERSION_V2, ANALYTICS_SCHEMA_VERSION_V2_CALLBACK, ANALYTICS_SCHEMA_VERSION_EVENT_STREAM, ANALYTICS_SCHEMA_VERSION_V3];

  if (!implementedSchemaVersions.includes(schemaVersion)) {
    var error = "The given schemaVersion of '" + schemaVersion + "' is not implemented.\n      Valid versions are " + implementedSchemaVersions.join(', ');
    throw new Error(error);
  }

  var parsedData;

  switch (schemaVersion) {
    case ANALYTICS_SCHEMA_VERSION_V2:
      parsedData = (0, _v["default"])(data);
      break;

    case ANALYTICS_SCHEMA_VERSION_V2_CALLBACK:
      parsedData = (0, _v2Callback["default"])(data);
      break;

    case ANALYTICS_SCHEMA_VERSION_V3:
      parsedData = (0, _v2["default"])(data);
      break;

    case ANALYTICS_SCHEMA_VERSION_EVENT_STREAM:
      parsedData = (0, _eventStream["default"])(data);
      break;

    default:
      // We shouldn't be able to get here. We already have an implemented schema check prior.
      break;
  }

  return parsedData;
};

var _default = analyticsParser;
exports["default"] = _default;